import { render, staticRenderFns } from "./ApartmentTable.global.vue?vue&type=template&id=25289d28&lang=pug&"
import script from "./ApartmentTable.global.vue?vue&type=script&lang=ts&"
export * from "./ApartmentTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports